// All projects shown on the home page, in display order.
// - page:     the project's folder in src/projects/
// - cover:    must use `new URL("<path>", import.meta.url)` so Parcel bundles the image
// - disabled: set to true to hide the project from the home page

export default {
    a_fantasy_story: {
        name: "A Fantasy Story",
        tags: ["Unity", "Co-op", "Game", "C#"],
        page: "projects/a_fantasy_story/index.html",
        cover: new URL("../projects/a_fantasy_story/assets/cover.png", import.meta.url)
    },
    another_door: {
        name: "Another Door",
        tags: ["JavaScript", "Game"],
        page: "projects/another_door/index.html",
        cover: new URL("../projects/another_door/assets/cover.png", import.meta.url)
    },
    endless_swarm: {
        name: "Endless Swarm",
        tags: ["JavaScript", "WebGL", "Pixi.js", "Game"],
        page: "projects/endless_swarm/index.html",
        cover: new URL("../projects/endless_swarm/assets/cover.png", import.meta.url)
    },
    cappuccino_hut: {
        name: "Cappuccino Hut",
        tags: ["Unity", "VR", "Game", "C#"],
        page: "projects/cappuccino_hut/index.html",
        cover: new URL("../projects/cappuccino_hut/assets/cover.png", import.meta.url)
    },
    last_cat_standing: {
        name: "Last Cat Standing",
        disabled: true,
        tags: ["Unity", "Game", "Blender", "C#"],
        page: "projects/last_cat_standing/index.html",
        cover: new URL("../projects/last_cat_standing/assets/cover.png", import.meta.url)
    },
    led_lamp: {
        name: "LED-lampa",
        tags: ["Python", "MicroPython", "Blender", "3D Printing", "Neopixel"],
        page: "projects/led_lamp/index.html",
        cover: new URL("../projects/led_lamp/assets/cover.png", import.meta.url)
    },
    minetrim: {
        name: "Minetrim",
        tags: ["JavaScript", "Website", "Three.js"],
        page: "projects/minetrim/index.html",
        cover: new URL("../projects/minetrim/assets/cover.png", import.meta.url)
    },
    apartment_display: {
        name: "Apartment Display",
        tags: ["Python", "Website", "Scraper", "JavaScript", "Leaflet.js", "BeautifulSoup"],
        page: "projects/apartment_display/index.html",
        cover: new URL("../projects/apartment_display/assets/cover.png", import.meta.url)
    }
};
